/* eslint-disable class-methods-use-this */
/*
 * Created Date: 02-08-2022, 9:53:42 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 APUSCORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { STUDIO_BE_URL } from 'env'
import { createInstance } from '.'
import { globalApiMiddleware } from './middleware'
import { isLocalhost } from '@Core/Helpers/Url'
import { SESSION_STORAGE, getDataSession, setDataSession } from '@Core/Helpers/Session'

class BaseService {
	BASE_URL = STUDIO_BE_URL

	BASE_ENDPOINT = ''

	pimaryKey = 'id'

	paramsGet = {
		sort: 'updated_at',
		dir: 'desc'
	}

	request = null

	APPLY_MIDDLEWARE = {
		...globalApiMiddleware
	}

	ALL_ITEMS = 1000

	constructor(params) {
		this.setRequest()
	}

	setRequest() {
		this.request = createInstance(this.BASE_URL, this.middleware)
	}

	/**
	 * Apply middleware request instance axios
	 * @param {requestConfig : axios} requestConfig
	 */
	middleware = requestConfig => {
		const arr = Object.values(this.APPLY_MIDDLEWARE).map(m => {
			if (typeof m === 'function') {
				return m(requestConfig)
			}
			return m
		})
		return arr
	}

	applyMiddleware = (key, middleware) => {
		this.APPLY_MIDDLEWARE[key] = middleware
	}

	/**
	 * Get all resource for paginate
	 * @param {}
	 * @returns
	 */
	list = (query = {}, config = {}) => {
		const params = { ...this.paramsGet, ...query }
		return this.request.get(this.BASE_ENDPOINT, { params, ...config })
	}

	/**
	 * Get specific of resource
	 * @param {int} id
	 * @param {object} config
	 * @returns
	 */
	find = (id, config = {}) => {
		const api = `${this.BASE_ENDPOINT}/${id}`
		return this.request.get(api, config)
	}

	/**
	 * Store a newly created resource in storage.
	 * @param {object} data
	 * @param {object} config
	 * @returns
	 */
	create = (data = {}, config = {}) => {
		return this.request.post(this.BASE_ENDPOINT, data, config)
	}

	/**
	 * Update the specified resource in storage.
	 * @param {object} data
	 * @param {object} config
	 * @returns
	 */
	update = (data = {}, config = {}) => {
		const { pimaryKey } = this
		return this.request.put(`${this.BASE_ENDPOINT}/${data[pimaryKey]}`, data, config)
	}

	save = (data = {}, config = {}) => {
		const { pimaryKey } = this
		// eslint-disable-next-line no-prototype-builtins
		if (data.hasOwnProperty(pimaryKey) && data[pimaryKey]) {
			return this.update(data, config)
		}
		return this.create(data, config)
	}

	listWithOptions = (query = {}, config = {}) => {
		const params = {
			...this.paramsGet,
			page: 1,
			size: this.ALL_ITEMS,
			is_active: true,
			...query
		}
		return this.request.get(this.BASE_ENDPOINT, { params, ...config })
	}

	/**
	 * Remove the specified resource from storage.
	 * @param {int} id
	 * @param {object} config
	 * @returns
	 */
	delete = (id, config = {}) => {
		const api = `${this.BASE_ENDPOINT}/${id}`
		return this.request.delete(api, config)
	}

	massDelete = ids => {
		const api = `${this.BASE_ENDPOINT}`
		const data = {
			ids
		}
		return this.request.delete(api, { data })
	}

	// default cache 1h
	withCache = async (fn, key, cacheTime = 1000 * 60 * 5) => {
		if (isLocalhost() || cacheTime === 0) {
			// const res = await fn()
			return fn()
		}

		const cache = getDataSession(SESSION_STORAGE, key) ?? {}
		// console.log('============= cache', cache)
		const currentTime = Date.now()
		if (cache?.data) {
			if (!cache.expired_time) {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						resolve(cache?.data)
					}, 100)
				})
			}
			if (cache.expired_time > currentTime) {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						resolve(cache?.data)
					}, 100)
				})
			}
		}

		const result = await fn()
		const time = cacheTime ? Date.now() + cacheTime : cacheTime

		try {
			setDataSession(SESSION_STORAGE, key, {
				data: result,
				expired_time: time
			})
		} catch (e) {
			console.log('============= error session', e)
		}
		return result
	}

	withExamDb = exam => {
		// this.request.defaults.headers.common.exam_id = exa
		if (exam?.db_name && exam?.db_connection) {
			this.request.defaults.headers.common.exam_db = exam?.db_name
			this.request.defaults.headers.common.exam_connection = exam?.db_connection
		}
		return this
	}
}

export default BaseService
